// Lightweight affiliate API client and session store.
const API_URL = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'plp_affiliate_session';

export const affiliateAuth = {
  getToken() {
    try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
  },
  setToken(token) {
    try { token ? localStorage.setItem(STORAGE_KEY, token) : localStorage.removeItem(STORAGE_KEY); } catch {}
  },
  clear() { try { localStorage.removeItem(STORAGE_KEY); } catch {} },
};

async function call(path, { method = 'GET', body, auth = false } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const tok = affiliateAuth.getToken();
    if (tok) {
      headers['Authorization'] = `Bearer ${tok}`;
      headers['X-Affiliate-Session'] = tok;
    }
  }
  const res = await fetch(`${API_URL}/api/affiliate${path}`, {
    method,
    headers,
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const err = new Error(data?.detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const affiliateAPI = {
  login: (email, password) => call('/login', { method: 'POST', body: { email, password } })
    .then(r => { if (r.session_token) affiliateAuth.setToken(r.session_token); return r; }),
  setupPassword: (setup_token, password) => call('/setup-password', { method: 'POST', body: { setup_token, password } })
    .then(r => { if (r.session_token) affiliateAuth.setToken(r.session_token); return r; }),
  forgotPassword: (email) => call('/forgot-password', { method: 'POST', body: { email } }),
  resetPassword: (reset_token, new_password) => call('/reset-password', { method: 'POST', body: { reset_token, new_password } }),
  logout: () => call('/logout', { method: 'POST', auth: true }).finally(() => affiliateAuth.clear()),
  me: () => call('/me', { auth: true }),
  dashboard: () => call('/dashboard', { auth: true }),
  sales: (page = 1, limit = 25) => call(`/sales?page=${page}&limit=${limit}`, { auth: true }),
  payouts: () => call('/payouts', { auth: true }),
  trackClick: (promoCode) => call(`/track-click/${encodeURIComponent(promoCode)}`, { method: 'POST' }),
};
